import React from 'react';
import AsyncHome from './async';
import AsyncAppSetting from './appsetting/async';
import DefaultLayout from '../../components/layout/DefaultLayout';
import {Trans} from 'react-i18next';
import {connect} from 'react-redux';
import SingleColumnLayout from '../../components/layout/SingleColumnLayout';
import smbUtils from '../../utils/smbUtils';

const Title = ({account: {firstName}, customer: {functionType}}) => {
  const type = smbUtils.getFunctionTypeI18n(functionType);
  return (
    <>
      <Trans i18nKey="p.home.title.hey">Hey {{firstName}}!</Trans>
      <br />
      <Trans i18nKey="p.home.title2">
        Welcome back to Online Service{' '}
        <span style={{fontWeight: '700'}}>{{type}}</span>!
      </Trans>
    </>
  );
};

const parent1 = {
  title: <Trans i18nKey="p.home.subtitle">Home Page</Trans>,
  path: '/',
};

const TitleWrapper = connect(
  state => ({
    account: state.components.auth.accountSummary.account,
    customer: state.components.auth.accountSummary.customer,
  }),
  null
)(Title);

export default [
  <DefaultLayout
    key="home"
    exact
    path="/"
    component={AsyncHome}
    title={<TitleWrapper />}
    subtitle={<Trans i18nKey="p.home.subtitle">Home Page</Trans>}
  />,
  <SingleColumnLayout
    exact
    key="appssettings"
    path="/home/start-guide"
    component={AsyncAppSetting}
    parents={[parent1]}
    title={<Trans i18nKey="p.s.home.start.guide">Start Guide</Trans>}
  />,
];
